module.exports = "pegasus/assets/theme4/l_d.png";